"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UseAnInsteadOfA = exports.RichTextParser = exports.LowerCaseFirstLetter = exports.CapitalizeFirstLetter = exports.Capitalize = void 0;
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
var _errorHelpers = require("./errorHelpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const RichTextParser = (richText, supportEscapedCharacters) => {
  // TODO: Not sure if this needs to be done too
  const adjustedText = richText.split('\r\n').join('<br/>');
  if (supportEscapedCharacters) {
    return (0, _htmlReactParser.default)(adjustedText);
  }
  return (0, _htmlReactParser.default)(richText);
};

/**
 * Takes a string and returns it with the first character capitalized and the remaining characters as lowercase.
 *
 * @param {string} pString - A string of text.
 * @returns {string || false} the capitalized string or the unchanged pString if anything other than a string is sent to it.
 */
exports.RichTextParser = RichTextParser;
const Capitalize = pString => {
  if (typeof pString !== 'string') {
    (0, _errorHelpers.LogError)({
      message: "Capitalize function called with a non-string parameter ".concat(pString)
    });
    return pString;
  }
  return "".concat(pString.substring(0, 1).toUpperCase()).concat(pString.substring(1).toLowerCase());
};
exports.Capitalize = Capitalize;
const CapitalizeFirstLetter = pString => {
  if (typeof pString !== 'string') {
    (0, _errorHelpers.LogError)({
      message: "CapitalizeFirstLetter function called with a non-string parameter ".concat(pString)
    });
    return pString;
  }
  return "".concat(pString.substring(0, 1).toUpperCase()).concat(pString.substring(1));
};
exports.CapitalizeFirstLetter = CapitalizeFirstLetter;
const LowerCaseFirstLetter = pString => {
  if (typeof pString !== 'string') {
    (0, _errorHelpers.LogError)({
      message: "LowerCaseFirstLetter function called with a non-string parameter ".concat(pString)
    });
    return pString;
  }
  return "".concat(pString.substring(0, 1).toLowerCase()).concat(pString.substring(1));
};
exports.LowerCaseFirstLetter = LowerCaseFirstLetter;
const UseAnInsteadOfA = word => {
  const lettersRequiringAn = ['a', 'e', 'i', 'o', 'u', 'h'];
  const firstLetter = word.substring(0, 1).toLowerCase();
  return lettersRequiringAn.indexOf(firstLetter) !== -1;
};
exports.UseAnInsteadOfA = UseAnInsteadOfA;